import React, { Component, Fragment } from 'react';
import {message } from 'antd';
import i18n from "../../../../../../constants/initLng";
import Input from '../../../../common/component/Input';
import TextArea from '../../../../common/component/TextArea';
import * as HMS from '../../../../common/component/Index';
import * as Func from '../../../../../../helpers/functions';
import './style.less';
import { DETAIL_ACTIONS } from '../../../../../../constants/Define';

export default class BasicInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const { loading, homestayRoomType, validation, action } = this.props;
        return (
            <div className="basic-info">
                <div className="basic-info-box">
                    <h3>{i18n.t(`item.homestayRoomType.basic_info`)}</h3>
                    <fieldset disabled={loading}>
                        <div className="form-group">
                            <HMS.FormWrapperInputComponent
                                isRequired={true}
                                isValidation={true}
                                dataValidation={homestayRoomType?.code}
                                validation={validation.code}
                                labelTitle={i18n.t(`item.homestayRoomType.code`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                            <Input onChange={this.props.onChange} name={`code`}  value={homestayRoomType?.code} disabled={loading} placeholder={i18n.t('item.homestayRoomType.code')} autoFocus/>
                        
                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="form-group">
                            <HMS.FormWrapperInputComponent
                                isRequired={true}
                                isValidation={true}
                                dataValidation={homestayRoomType?.name}
                                validation={validation.name}
                                labelTitle={i18n.t(`item.homestayRoomType.name`)}
                            >
                                <Input onChange={this.props.onChange} name={`name`} value={homestayRoomType?.name} disabled={loading} placeholder={i18n.t('item.homestayRoomType.name')} />
                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="form-group">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.homestayRoomType.maxOccupancy`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                            <Input onChange={this.props.onChange} name={`maxOccupancy`} value={Func.formatMoney(Func.checkUndefine(homestayRoomType.maxOccupancy))} disabled={loading} placeholder={i18n.t('item.homestayRoomType.maxOccupancy')}/>
                        
                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="form-group">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.homestayRoomType.shortDescription`)}
                            >
                                <TextArea onChange={this.props.onChange} name={`shortDescription`}  value={homestayRoomType.shortDescription} disabled={loading} placeholder={i18n.t('item.homestayRoomType.shortDescription')} />
                            </HMS.FormWrapperInputComponent>
                        </div>

                        <div className="form-group">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.homestayRoomType.description`)}
                            >
                                <TextArea onChange={this.props.onChange} name={`description`} value={homestayRoomType.description} disabled={loading} placeholder={i18n.t('item.homestayRoomType.description')} />
                            </HMS.FormWrapperInputComponent>
                        </div>
                    </fieldset>
                </div>
            </div>
        );
    }
}

